<template>
  <div class="myProblemContainer" id="myProblemContainer">
    <el-card>
      <div class="header">
        <div class="goback" @click="goBack">
          <img src="../assets/goback.png" alt />
          <span>返回</span>
        </div>
        <div class="mark">
          <img src="../assets/location.png" alt />
          <span>专家服务-我的问题</span>
        </div>
      </div>
      <div class="main" v-if="total>0">
        <el-row :gutter="14">
          <el-col :span="8" v-for="(item,index) in data" :key="index">
            <div class="item" @click="goDetails(item.gid)">
              <div class="top">
                <div class="title">{{item.title}}</div>
                <div
                  :class="['status', item.status === 0 ? 'mark1' : 'mark2']"
                >{{item.status === 0 ? '待回答' : '已回答'}}</div>
              </div>
              <div class="content">{{item.content}}</div>
              <div class="bottom">
                <div class="time">{{item.releasetime}}</div>
                <div class="delete" @click.stop="deleteItem(item.gid)">
                  <i class="el-icon-delete"></i>
                  删除
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="promptInfo" v-else>暂无问题</div>
      <Pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="size"
        @pagination="handleChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getServerData } from "../utils/fetchData";
import { APIMAP } from "../constants/apiConstants";
import Pagination from "@/components/common/Pagination";
import { mapState } from "vuex";

export default {
  components: {
    Pagination
  },
  name: "MyProblem",
  data() {
    return {
      data: [],
      page: 1,
      size: 10,
      total: 0
    };
  },
  created() {
    this.getData();
    // console.log(this.userInfo);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goDetails(gid) {
      this.$router.push({
        path: "/problemDetails",
        query: { gid }
      });
    },
    // 获取数据
    async getData() {
      const { page, size } = this;
      let params = {};
      params.page = page;
      params.size = size;
      params.pid = this.userInfo.platformid;
      if (this.userInfo.rolename === "pm2.5专家组") {
        params = {
          ...params,
          expertid: this.userInfo.gid
        };
      }else{
        params = {
          ...params,
          uid: this.userInfo.gid
        };
      }
      console.log("参数详情", params);
      try {
        const res = await getServerData(APIMAP.EXPERTASK, params);
        console.log("获取数据", res);
        this.data = res.rows;
        this.total = res.total;
      } catch (error) {
        console.log(error);
      }
    },
    // 分页
    handleChange() {
      this.getData();
    },
    // 删除
    async deleteItem(id) {
      const res = await this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (res === "confirm") {
        console.log(id);
        try {
          const result = await getServerData(
            APIMAP.EXPERTASK,
            { gid: id },
            "delete"
          );
          console.log("删除返回的数据", result);
          // this.data = this.data.filter((item) => item.gid !== id);
          this.$message.success("删除成功");
          this.getData();
        } catch (error) {
          console.log(error);
        }
      }
    }
  },
  computed: {
    ...mapState(["userInfo", "problemNum"])
  }
};
</script>

<style lang='less' scoped>
.myProblemContainer {
  padding: 24px 26px 0;
  width: 100%;
  .el-card {
    width: 100%;
    min-width: 1133px;
    min-height: 949px;
    margin-bottom: 40px;
    .header {
      display: flex;
      align-items: center;
      height: 86px;
      border-bottom: 1px solid #e2e5ec;
      .goback {
        display: flex;
        align-items: center;
        width: 58px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #99a9ba;
        line-height: 22px;
        margin-right: 23px;
        cursor: pointer;
        img {
          margin-right: 8px;
        }
      }
      .mark {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #99a9ba;
        img {
          margin-right: 7px;
        }
      }
    }
    .promptInfo {
      margin-top: 100px;
      text-align: center;
      font-size: 16px;
      color: #99a9ba;
    }
    .main {
      margin-top: 30px;
      .item {
        background: #f8fafb;
        padding: 18px 17px 0 18px;
        margin-bottom: 12px;
        cursor: pointer;
      }
      .top {
        width: 100%;
        height: 22px;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          width: 80%;
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          color: #2c3a50;
          letter-spacing: 3px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .status {
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Regular;
        }
      }
      .content {
        height: 90px;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #8c8f9a;
        line-height: 22px;
        letter-spacing: 1px;
        margin-bottom: 20px;
        // 多行文字溢出问题
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      .bottom {
        height: 48px;
        border-top: 1px solid #e2e5ec;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .time {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #99a9ba;
        }
        .delete {
          font-size: 15px;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #969aa5;
          letter-spacing: 1px;
          cursor: pointer;
        }
      }
    }
  }
  .mark1 {
    color: #ff7673;
  }
  .mark2 {
    color: var(--themeColor);
  }
}
</style>